<script>
import options from './StafetPayment.options'
export default options
</script>

<template>
  <article class="kb-stafet-flow-payment">
    <h2 class="kb-stafet-step__title">{{ title }}</h2>

    <ul class="kb-stafet-flow-payment__list"
        v-if="basket.length > 0">
      <template v-for="(item, index) in basket" :key="index">
        <li class="kb-stafet-flow-payment__list-item">
          <p>{{ item.label }}</p>
          <p>{{ item.amount }}</p>
          <p>{{ item.price }}</p>
        </li>
      </template>
      <li class="kb-stafet-flow-payment__list-item kb-stafet-flow-payment__list-item--total">
        <p>{{ inTotalLabel }}</p>
        <p></p>
        <p>{{ inTotalPrice }} kr.</p>
      </li>
    </ul>
  </article>
</template>
